import React from 'react';
import image from '../../assets/images/error.png';
import { getLabelsByLanguage } from '../../../utilites/util';
import classNames from 'classnames';

interface Props {
  removeHorizontalPadding?: boolean;
}

const ErrorDisplay: React.FC<Props> = ({ removeHorizontalPadding }) => {
  const labels = getLabelsByLanguage();

  return (
    <section className={classNames('d-flex', removeHorizontalPadding ? 'pt-5 pb-5' : 'p-5', 'flex-flow-column')}>
      <img
        src={image}
        style={{
          width: 'auto',
          maxHeight: 600,
          objectFit: 'contain',
        }}
        alt={labels.errorPageMessage}
      />

      <article className="text-center">
        <h3 className="fw-bold pt-5 pb-3">{labels.errorPageTitle}</h3>
        <h5 className="fw-bold text-20">{labels.errorPageMessage}</h5>
      </article>
    </section>
  );
};

export default ErrorDisplay;
